import React, { Component, useContext } from 'react'
import { PARTY_COLORS } from '../../constants/colors'
import { OverlayComponent } from 'components/overlay/component'
import Img from 'react-image'
import OnVisible from 'react-on-visible'
import { isBrowser } from 'react-device-detect'
import _ from 'lodash'
import { Search, Grid, Label } from 'semantic-ui-react'
import './styles.scss'
import { partyOrder } from '../../constants/partyOrder.js'

import { LocaleContext } from 'contexts/locale'

type Props = {
  data: string[]
  updateHandler: Function
  council: string
  locale: string[]
  el: string[]
  globalLocale: string[]
  showAll: boolean
  hasFilter: boolean
}

type State = {
  isLoading: boolean
  locale: string[]
  globalLocale: string[]
  filterableMembers: Record<string, any>
  value: string
  isOpen: boolean
  amountVisible: number
}

const initialState = {
  isLoading: false,
  locale: [],
  globalLocale: [],
  value: '',
  filterableMembers: [],
  isOpen: false,
  amountVisible: 0
}

class ListItemComponent extends Component<Props, State> {
  state = initialState

  escapeName(str) {
    // Replace all weird chars
    const escapedString = str
      .replace(/ä/gi, 'a')
      .replace(/à/gi, 'a')
      .replace(/â/gi, 'a')
      .replace(/ö/gi, 'o')
      .replace(/ô/gi, 'o')
      .replace(/ü/gi, 'u')
      .replace(/û/gi, 'u')
      .replace(/ù/gi, 'u')
      .replace(/é/gi, 'e')
      .replace(/è/gi, 'e')
      .replace(/ê/gi, 'e')
      .replace(/ë/gi, 'e')
      .replace(/ç/gi, 'c')
      .replace(/ï/gi, 'i')
      .replace(/î/gi, 'i')
      .replace(/ /g, '')
      .replace(/'/g, '')
    return escapedString
  }

  getBirthday(date) {
    if (!date) {
      return '?'
    }
    const day = date.split('.')[0]
    const month = date.split('.')[1]
    const year = date.split('.')[2]

    const today = new Date()
    const birthDate = new Date(year + '-' + month + '-' + day)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  render() {
    const { el } = this.props
    const { isOpen } = this.state

    const birthday = this.getBirthday(el.Geburtsdatum)

    const ImagePlaceholder = (showLoader, party) => (
      <img
        src={require('./transparent.png')}
        className='ui avatar image'
        style={{
          opacity: showLoader ? 0.5 : 1,
          backgroundColor: PARTY_COLORS[party]
        }}
      />
    )

    return (
      <div
        style={{
          display:
            el.Elected === 'Ja' && this.props.visible && el.Sitznummer
              ? 'block'
              : 'none'
        }}
        className='item'
        onClick={() => this.setState({ isOpen: !this.state.isOpen })}
      >
        {!isOpen && (
          <Img
            src={`https://interaktiv.tagesanzeiger.ch/imageUpload/interaktives-parlament/${this.escapeName(
              el.Nachname
            )}_${this.escapeName(el.Vorname)}.png`}
            className='ui avatar image'
            style={{
              backgroundColor: PARTY_COLORS[el.Partei]
            }}
            loader={ImagePlaceholder(true, el.Partei)}
            unloader={ImagePlaceholder(false, el.Partei)}
          />
        )}
        <div className='content'>
          <a className='header' style={{ color: 'black' }}>
            {el.Vorname} {el.Nachname}
            {el['Funktion ' + this.context] && (
              <span style={{ fontWeight: 400 }}>
                , {el['Funktion ' + this.context]}
              </span>
            )}
            <i className={`icon chevron ${isOpen ? 'up' : 'right'}`} />
          </a>
          <div className='description'>
            <span style={{ color: PARTY_COLORS[el.Partei] }}>
              <strong>
                {this.props.globalLocale.UI.Global.Parties[el.Partei]}
                {'  '}
              </strong>
            </span>
            {this.props.globalLocale.UI.Global.Cantons[el.Kanton]}
            {this.state.isOpen && (
              <div className='ui vertical aligned segment'>
                <table
                  className={`ui ${
                    isBrowser ? 'small' : 'mini very compact'
                  } basic very compact unstackable table`}
                >
                  <tbody>
                    <tr className='top aligned'>
                      <td style={{ paddingRight: '0.25rem' }}>
                        <h4
                          className='ui header'
                          style={{
                            paddingRight: '2rem',
                            marginBottom: '0.2rem'
                          }}
                        >
                          {el.Vorname} {el.Nachname}
                        </h4>

                        <span
                          style={{
                            display: 'inline-block',
                            paddingRight: '1rem'
                          }}
                        >
                          {el['DabeiSeit ' + this.context]}
                        </span>

                        <br />

                        {el['Fraktion ' + this.context] && (
                          <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                            {el['Fraktion ' + this.context]}
                            <br />
                          </span>
                        )}

                        <span
                          style={{
                            paddingTop: '.5rem',
                            display: 'inline-block'
                          }}
                        >
                          {el['Beruf ' + this.context] && (
                            <span>
                              {el['Beruf ' + this.context]}
                              <br />
                            </span>
                          )}
                          {el.Geburtsdatum && (
                            <span>
                              {birthday}{' '}
                              {this.props.globalLocale.UI.Global.General.years}
                              ,&nbsp;
                            </span>
                          )}
                          {el['Wohnort ' + this.context] && (
                            <span>{el['Wohnort ' + this.context]}</span>
                          )}
                        </span>
                      </td>
                      <td rowSpan={5} className='collapsing right aligned'>
                        <Img
                          src={`https://interaktiv.tagesanzeiger.ch/imageUpload/interaktives-parlament/${this.escapeName(
                            el.Nachname
                          )}_${this.escapeName(el.Vorname)}.png`}
                          className={`ui circular ${
                            isBrowser ? 'small' : 'small'
                          } image`}
                          style={{
                            backgroundColor: PARTY_COLORS[el.Partei]
                          }}
                          loader={ImagePlaceholder(true)}
                          unloader={ImagePlaceholder(false)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ marginTop: '1rem' }}>
                  {el['Text ' + this.context]}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export class ListComponent extends Component<Props, State> {
  state = initialState

  componentWillMount() {
    const locale = this.context
    const messages = require('./locales/' + locale + '.yml')
    const globalMessages = require('locales/' + locale + '.yml')
    this.setState({
      locale: messages,
      globalLocale: globalMessages,
      filterableMembers: this.props.data.filter(el => el.Elected === 'Ja')
    })
  }

  componentDidMount() {
    const sortedByName = this.props.data.sort((a, b) => b.Nachname - a.Nachname)
    this.setState({
      filterableMembers: sortedByName.filter(el => el.Elected === 'Ja')
    })
  }

  handleResultSelect = (e, { result }) => {
    this.setState({ value: result.Vorname + ' ' + result.Nachname })
    this.props.updateHandler(null, result.Vorname, result.Nachname)
  }

  render() {
    const { filterableMembers, isOpen, locale } = this.state

    /* Find out which members are currently visible in parliament */
    /* ... by looping all paths and checking for .inactive class */

    const allPaths = document.querySelectorAll(
      'svg#' + this.props.council + ' path'
    )
    const activePaths = document.querySelectorAll(
      'svg#' + this.props.council + ' path:not(.inactive)[data-name]'
    )
    // console.log(allPaths.length + ' / ' + activePaths.length)

    const allVisiblePoliticians = []
    for (let i = 0; i < activePaths.length; i++) {
      if (activePaths[i].getAttribute('data-name') !== ' ') {
        allVisiblePoliticians.push(activePaths[i].getAttribute('data-name'))
      }
    }

    const sortedMembers = _.sortBy(
      filterableMembers,
      el => [
        el.Partei.toLowerCase(),
        el.Nachname.toLowerCase(),
        el.Vorname.toLowerCase()
      ],
      _.values
    )

    const AllListItems = sortedMembers
      .sort(
        (a, b) => partyOrder.indexOf(a.Partei) - partyOrder.indexOf(b.Partei)
      )
      .map((el, i) => (
        <ListItemComponent
          el={el}
          globalLocale={this.state.globalLocale}
          locale={this.state.locale}
          key={`list-item-${i}`}
          visible
        />
      ))

    const VisibleListItems = this.props.data
      .sort(
        (a, b) => partyOrder.indexOf(a.Partei) - partyOrder.indexOf(b.Partei)
      )
      .map((el, i) => (
        <ListItemComponent
          el={el}
          globalLocale={this.state.globalLocale}
          locale={this.state.locale}
          key={`list-item-${i}`}
          visible={
            allVisiblePoliticians.indexOf(el.Vorname + ' ' + el.Nachname) >= 0
          }
        />
      ))

    return (
      <div className='ui vertical aligned basic segment selection list-container container text container'>
        <div style={{ textAlign: 'center' }}>
          {allPaths.length === activePaths.length && (
            <div>
              {!isOpen ? (
                <button
                  className='ui active blue inverted icon button'
                  onClick={() => this.setState({ isOpen: true })}
                >
                  <i className='icon list' />{' '}
                  {locale.ShowAll[this.props.council]}
                </button>
              ) : (
                <button
                  className='ui active blue inverted icon button'
                  onClick={() => this.setState({ isOpen: false })}
                >
                  <i className='icon chevron up' />{' '}
                  {locale.HideAll[this.props.council]}
                </button>
              )}
            </div>
          )}
        </div>
        {filterableMembers &&
          isOpen &&
          !this.props.hasFilter &&
          VisibleListItems.length !== filterableMembers.length && (
            <div
              className='ui relaxed divided list'
              style={{ fontFamily: 'var(--chart-font-stack)' }}
            >
              <p
                className='ui tiny horizontal divider header infographic'
                style={{
                  margin: '1.25rem auto',
                  fontWeight: 'normal',
                  opacity: 0.5
                }}
              >
                <i className='icon filter' style={{ marginRight: '.3rem' }} />
                {
                  this.props.data.filter(
                    el =>
                      allVisiblePoliticians.indexOf(
                        el.Vorname + ' ' + el.Nachname
                      ) >= 0
                  ).length
                }{' '}
                {allVisiblePoliticians.length === 1
                  ? locale.Sort.Filter[0]
                  : locale.Sort.Filter[1]}
              </p>
              {AllListItems}
            </div>
          )}
        {allPaths.length !== activePaths.length &&
          this.props.data.filter(
            el =>
              allVisiblePoliticians.indexOf(el.Vorname + ' ' + el.Nachname) >= 0
          ).length > 0 && (
            <div
              className='ui relaxed divided list'
              style={{ fontFamily: 'var(--chart-font-stack)' }}
            >
              <p
                className='ui tiny horizontal divider header infographic'
                style={{
                  margin: '1.25rem auto',
                  fontWeight: 'normal',
                  opacity: 0.5
                }}
              >
                <i className='icon filter' style={{ marginRight: '.3rem' }} />
                {
                  this.props.data.filter(
                    el =>
                      allVisiblePoliticians.indexOf(
                        el.Vorname + ' ' + el.Nachname
                      ) >= 0
                  ).length
                }{' '}
                {allVisiblePoliticians.length === 1
                  ? locale.Sort.Filter[0]
                  : locale.Sort.Filter[1]}
              </p>
              {VisibleListItems}
            </div>
          )}
      </div>
    )
  }
}

ListComponent.contextType = LocaleContext
ListItemComponent.contextType = LocaleContext
